import { Client } from "../models/General";

export const clients: Client[] = [
  {
    name: "flcit-chemit-storage-handling",
    value: "9740a572-abfa-429b-926d-d1c9bd27bff3",
    layer: "process",
  },
  {
    name: "flcit-chemit-tms-nonprod",
    value: "c8163bea-de9a-45d3-aa25-b19af3705a79",
    layer: "process",
  },
  {
    name: "flcit-chemit-entitlement-api-acc",
    value: "c85db5f8-8227-43a5-97f0-639287a03201",
    layer: "process",
  },
  {
    name: "sccot-sc-mainsaver-common-nonprod",
    value: "a9d2a525-5fed-48fc-ac07-f5e58ca0374e",
    layer: "process",
  },
  {
    name: "sccot-sc-mainsaver-main-nonprod",
    value: "c59a149e-b755-407e-ab0e-d2d6fbd94417",
    layer: "process",
  },
  {
    name: "sccot-sc-mvf-nonprod",
    value: "b3565f0e-cb97-41e5-80c1-15791d036437",
    layer: "process",
  },
  {
    name: "sccot-sc-logistics-brightsize-nonprod",
    value: "6c673ffa-ad4a-4897-bd45-8320b08eb391",
    layer: "process",
  },
  {
    name: "sccot-sc-adapter-hana-o9-nonprod",
    value: "d47bd93d-5663-4d95-95c0-4b4c3cf665ac",
    layer: "process",
  },
  {
    name: "sccot-sc-experience-inspection-lot-result-nonprod",
    value: "ec90cd98-d096-4167-afa0-dc2b5a0cbe25",
    layer: "process",
  },
  {
    name: "sccot-sc-experience-goods-movement-nonprod",
    value: "f455bc8f-fe39-41d1-9196-06a0bf3f46cd",
    layer: "process",
  },
  {
    name: "sccot-sc-experience-production-nonprod",
    value: "911c1f03-69b8-42e6-ad31-cee6956b8928",
    layer: "process",
  },
  {
    name: "tprm-sayari-nonprod",
    value: "cd123fb5-11eb-40dd-83c3-1fdac1e3ec55",
    layer: "process",
  },
  {
    name: "sccot-sc-mm-sos-api-nonprod",
    value: "a46e4e40-2d98-4f90-b6fe-99fb281dd98b",
    layer: "process",
  },
  {
    name: "sccot-sc-do-garner-pub-dev",
    value: "67fe417d-1371-461b-9776-077192e37485",
    layer: "process",
  },
  {
    name: "sccot-sc-do-garner-pub-acc",
    value: "5fbe5dee-ca01-4e8e-9bc7-6178193a8dcf",
    layer: "process",
  },
  {
    name: "sccot-sc-do-garner-sub-nonprod",
    value: "9c47cb1d-a460-4920-a476-f90a521a229a",
    layer: "process",
  },

  {
    name: "chemical-test-app-okta",
    description:
      "write:chem-wim:plant-to-plant;write:chem-storage-handling:goods-receipt;read:chem-storage-handling:plant;write:chem-wim:pwo webhook-edit;read:chem-customer;write:chem-storage-handling:material-movement;write:chem-wim:quality-data",
    value: "0oac8qj9i2fmcx8xo1d7",
    layer: "experience",
    environment: ["development", "acceptance"],
  },
  {
    name: "chemit-c1-ba-tms-01-test-okta",
    description:
      "write:chem-wim:plant-to-plant;write:chem-tms:shipment;write:chem-tms:freight-cost;write:chem-tms:delivery",
    value: "0oac8q9nthHbIj8cM1d7",
    layer: "experience",
  },
  {
    name: "chemit-ca-ba-tms-01-okta",
    description:
      "write:chem-tms:shipment;write:chem-storage-handling:goods-receipt;write:chem-tms:freight-cost;write:chem-tms:delivery;write:chem-storage-handling:material-movement",
    value: "0oaaxl0068DkWvuGl1d7",
    layer: "experience",
  },
  {
    name: "chemit-ca-ba-tms-02-okta",
    description:
      "write:chem-tms:shipment;write:chem-tms:freight-cost;write:chem-tms:delivery",
    value: "0oab3mq74pPrWApyv1d7",
    layer: "experience",
  },
  {
    name: "chemit-ff-bdp-acc-okta",
    description: "write:chem-shipment:oceanbooking",
    value: "0oabet94iwos8mSNB1d7",
    layer: "experience",
  },
  {
    name: "chemit-ff-buyco-acc-okta",
    description: "write:chem-shipment:oceanbooking",
    value: "0oabesuytrHmeeVw81d7",
    layer: "experience",
  },
  {
    name: "chemit-ff-db-schenker-acc-okta",
    description: "write:chem-shipment:oceanbooking",
    value: "0oabet0j78eZLK4zm1d7",
    layer: "experience",
  },
  {
    name: "chemit-ff-elite-acc-okta",
    description: "write:chem-shipment:oceanbooking",
    value: "0oabesqdme3vxuLV41d7",
    layer: "experience",
  },
  {
    name: "chemit-oif-allocation",
    description: "webhook-edit",
    value: "0oab3oq5jxvA9pdDy1d7",
    layer: "experience",
  },
  {
    name: "chemit-oif-salesorder",
    description: "webhook-edit",
    value: "0oab3orpcxtoF3JhQ1d7",
    layer: "experience",
  },
  {
    name: "chemit-transporeon-acc-okta",
    description: "write:chem-tms:freight-cost",
    value: "0oabessh8lFwsHgJx1d7",
    layer: "experience",
  },
  {
    name: "chemit-transporeon-okta-test",
    description: "write:chem-tms:freight-cost",
    value: "0oab3pm9y7oWLuLlG1d7",
    layer: "experience",
  },
  {
    name: "chemical-test-lab-okta",
    description: "write:chem-wim:quality-data",
    value: "0oac8pgft6YEmqdh31d7",
    layer: "experience",
  },
  {
    name: "chemit-ca-ba-wim-01-okta",
    description:
      "write:chem-wim:plant-to-plant;write:chem-wim:pwo-production;write:chem-storage-handling:goods-receipt;read:chem-storage-handling:plant;write:chem-wim:pwo;read:chem-customer;write:chem-wim:pwo-rebulk;write:chem-storage-handling:material-movement;write:chem-wim:quality-data",
    value: "0oacj8ad1bENI68TJ1d7",
    layer: "experience",
  },
  {
    name: "chemit-us-solids-control-tower-ACC-okta",
    description: "write:us-solids-control-tower",
    value: "0oaaxkz5ggzli21Bp1d7",
    layer: "experience",
  },

  // Example of adding new client for outbound layer
  // {
  //   name: "webhook-global-api-nonprod",
  //   value: "78041deb-67ff-49ff-becf-356f09328c9c",
  //   layer: "outbound",
  // },
  {
    name: "webhook-global-api-nonprod",
    value: "78041deb-67ff-49ff-becf-356f09328c9c",
    layer: "outbound",
  },
  {
    name: "webhook-global-api-prod",
    value: "f9973721-621a-4bcd-a3f8-dd5aaa29e8de",
    layer: "outbound",
  },


];
